import { Component, input } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { FooterLinkComponent } from '@shared/components/footer-link/footer-link.component';
import { TemplateComponent } from '@shared/components/template/template.component';
import { FooterFirstVariantConfig } from '@shared/models';

@Component({
  selector: 'b2c-variant1',
  styleUrl: './variant1.component.scss',
  templateUrl: './variant1.component.html',
  imports: [FooterLinkComponent, TemplateComponent],
})
export class Variant1Component extends BaseComponent {
  config = input.required<FooterFirstVariantConfig>();
}
